import { useSyncExternalStore } from "react";
import {
  getActiveSchoolId,
  subscribeActiveSchoolId,
} from "../services/dataService";

export function useActiveSchoolId() {
  return useSyncExternalStore(
    subscribeActiveSchoolId,
    getActiveSchoolId,
    getActiveSchoolId
  );
}

export default useActiveSchoolId;
